import { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { createMarkup } from '../Helpers/FormHelper';

export function ImageInfo({ pageId }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState();

  useEffect(() => {
    console.log('component mounted!');
    const populateData = async () => {
      try {
        await axios.get(`/image/bypage/${pageId}`)
          .then((response) => {
            let array = [];

            for (let i = 0; i < 1; i++) {
              if (response.data[i]) {
                array.push(response.data[i]);
              } else {
                array.push({
                  Id: i,
                  filePath: "/images/banner_logo.png",
                  altText: "Wild Horse and Burro Stewardship Program Logo",
                });
              }
            }
            setData(array);
            console.log(response.data.length);
            setIsLoading(false);
          });
      } catch (e) {
        setError(e.message);
        setIsLoading(false);
      }
    }
    populateData();
  }, [pageId])

  if (isLoading)
    return (<h1><em>Loading Images...</em></h1>);
  if (error)
    return (<h2><b>Problem loading images: {error}</b></h2>);
  if (data) {
    return (
      <div className="row">
        {data.map((imgInf, index) => (
          <div className="col-sm-12" key={index}>
            <div className="card">
              <img className="card-img" src={`${imgInf.filePath}`} alt={`${imgInf.altText}`} />
              <div className={`card-img-overlay ${imgInf.overlayText ? "" : "hide"}`} >
                <div className="card-text" dangerouslySetInnerHTML={createMarkup(imgInf.overlayText)}></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
  return (<p>No data yet</p>);
}

ImageInfo.propTypes = {
  pageId: PropTypes.number.isRequired
}
